import { render, staticRenderFns } from "./PreviewSmallVideo.vue?vue&type=template&id=70668c24&scoped=true&"
import script from "./PreviewSmallVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewSmallVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSmallVideo.vue?vue&type=style&index=0&id=70668c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70668c24",
  null
  
)

export default component.exports